export const errorMessages = {
  EMPTY: 'Veuillez renseigner ce champs',
  INVALID_ENTRY: 'Saisie incorrecte',
  MIN_VALUE: 'La valeur saisie ne peut être inférieur à 0',
  INVALID_DURATION: 'La durée doit être comprise entre 7 ans et 25ans',
}
